import axios from 'axios';
import { notification } from 'antd';
import { UnauthorizedHandler } from '../js/helper/UnauthorizedHandler';
import { ACTION_TYPES } from '../redux/state-areas/user/constants';

const baseUrl = process.env.REACT_APP_API_URL;
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
const config = {
  headers: { Authorization: '' },
};

export const verifyUser = (data, callBack) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.put(`${baseUrl}/register/confirmEmail`, data, config);
      dispatch({
        type: 'successUser',
        payload: res,
      });
      dispatch({
        type: 'confirmEmail'
      })
      if (callBack) {
        callBack();
      }
      //   callBack();
      notification.success({
        message: 'User Verified',
        placement: 'bottomRight',
      });
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: 'error',
        payload: error,
      });
      notification.error({
        message: 'Failed to verify user',
        placement: 'bottomRight',
      });
    }
  };
};

export const getUsers = (workspaceId) => {
  return async (dispatch) => {
    try {
      workspaceId = workspaceId || sessionStorage.getItem('workspaceId') || localStorage.getItem('workspaceId');
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.get(`${baseUrl}/users/workspaces/${workspaceId}`, config);
      dispatch({
        type: 'success-get',
        payload: res.data.data,
      });
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: 'error',
        payload: error,
      });
    }
  };
};

// get user by id
export const getUser = (userId, callback, loggedInUser = true) => {
  return async (dispatch, getState) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      if (!userId) {
        userId = localStorage.getItem('Id');
      }

      // Skip fetch if we already have this user's data in Redux (for the logged-in user)
      if (loggedInUser) {
        const existingUser = getState().userReducer?.user;
        if (existingUser?._id === userId && callback) {
          callback(existingUser);
          return existingUser;
        }
      }

      dispatch({
        type: ACTION_TYPES.GET_USER_REQUEST,
        payload: {
          userId
        }
      });

      const res = await axios.get(`${baseUrl}/user/${userId}`, config);

      if (loggedInUser) {
        dispatch({
          type: 'user',
          payload: res.data.data,
        });
        dispatch({
          type: ACTION_TYPES.GET_USER_REQUEST_SUCCESS,
          payload: res.data.data,
        });
        dispatch({
          type: 'set-toggle-onboarding',
          payload: res?.data?.data?.onboarding !== 'complete',
        });
      }
      if (callback) {
        callback(res.data.data);
      }
      return res.data.data;
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: 'error',
        payload: error,
      });
    }
  };
};

export const setUnauthorized = (message) => {
  return (dispatch) => {
    dispatch({
      type: 'unauthorizedError',
      payload: message
    })
  }
}

export const clearUnauthorized = () => {
  return (dispatch) => {
    dispatch({
      type: 'clearUnauthorizedError'
    })
  }
}

export const setForbidden = (message) => {
  return (dispatch) => {
    dispatch({
      type: 'forbiddenError',
      payload: message
    })
  }
}

export const clearForbidden = () => {
  return (dispatch) => {
    dispatch({
      type: 'clearForbiddenError'
    })
  }
}

export const getUsersWithSameWorkSpace = () => {
  return async (dispatch) => {
    try {
      const workspaceId = sessionStorage.getItem('workspaceId') || localStorage.getItem('workspaceId');
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      const res = await axios.get(`${baseUrl}/users/workspaces/${workspaceId}`, config);
      dispatch({
        type: 'success-get',
        payload: res.data.data,
      });
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: 'error',
        payload: error,
      });
    }
  };
};

export const editUser = (data, callBack) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      const res = await axios.put(`${baseUrl}/user/edit`, data, config);

      notification.success({
        message: "Updated",
        placement: 'bottomRight',
      });

      dispatch({
        type: 'user',
        payload: res?.data?.data,
      });

      callBack && callBack();
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: "user-errorr",
        payload: error,
      });
    }
  };
};

export const uploadUserAvi = (data, callBack) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      const res = await axios.post(`${baseUrl}/users/uploadAvi`, data, config);
      // await dispatch({
      //   type: "user-success",
      //   payload: res,
      // });
      callBack && callBack();
      return res.data?.data || {};
    } catch (error) {
      UnauthorizedHandler(dispatch, error);
      dispatch({
        type: "user-errorr",
        payload: error,
      });
    }
  };
};

export const getAllUsersForAdminView = ({ page = 1, pageSize = 50 } = {}) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      const res = await axios.get(`${baseUrl}/users/admin/all`, { ...config, params: { page, pageSize } });
      const data  = res?.data?.data || [];
      const total = res?.data?.total ?? 0;
      dispatch({ type: 'setAllUsers', payload: data, total, append: page > 1 });
      return { data, total };
    } catch (error) {
      console.log("----- error", error);
      UnauthorizedHandler(dispatch, error);
    }
  };
}

export const pinItemToWorkspace = (data, pinned = true, entity) => {
  return async (dispatch) => {
    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      await axios.post(
        `${baseUrl}/user/entity/${pinned ? "pin" : "unpin"}`,
        data,
        config,
      );
      await dispatch({
        type: 'toggle-pin-item',
        payload: {
          data,
          isPinned: pinned,
          entity
        }
      });
      await dispatch({
        type: 'update-pin-project',
        payload: {
          data,
          isPinned: pinned,
          entity
        }
      });
      await dispatch({
        type: 'update-pin-portfolio',
        payload: {
          data,
          isPinned: pinned,
          entity
        }
      });
      return;
    } catch (error) {
      dispatch({
        type: 'error',
        payload: error,
      });
    }
  };
}